import React from 'react'

import { Input } from 'components/form'

const AvailabilityInput = ({ value = {}, onChange }) => (
    <Input
      type="text"
      value={value.value || ''}
      placeholder="f.eks. mandag og onsdag eller annenhver helg eller 10 timer i uka"
      onChange={e =>
        onChange({ ...value, type: 'other', value: e.target.value })
      }
    />
)

export default AvailabilityInput



// WEBPACK FOOTER //
// ./src/components/form/AvailabilityInput.js